export const ASSIGNMENT_DURATION_OPTIONS = [
  0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180, 195, 210, 225, 240,
].map((value) => ({
  label: value + ' Mins',
  value,
}));

export const HOMEWORK_DURATION_OPTIONS = [
  0, 60, 120, 180, 240, 300, 360, 420, 480, 540, 600, 660, 720, 780, 840, 900,
  960, 1020, 1080, 1140, 1200, 1260, 1320, 1380, 1440,
].map((value) => ({
  label: value + ' Mins',
  value,
}));

export const PRE_READ_DURATION_OPTIONS = [
  0, 60, 120, 180, 240, 300, 360, 420, 480, 540, 600, 660, 720, 780, 840, 900,
  960, 1020, 1080, 1140, 1200, 1260, 1320, 1380, 1440,
].map((value) => ({
  label: value + ' Mins',
  value,
}));

export const LIVE_LECTURE_DURATION_OPTIONS = [
  0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180, 195, 210, 225, 240,
  600,
].map((value) => ({
  label: value + ' Mins',
  value,
}));

export const CONTEST_DURATION_OPTIONS = [
  0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 390, 420, 450,
  480, 510, 540, 570, 600, 630, 660, 690, 720, 750, 780, 810, 840, 870, 900,
  930, 960, 990, 1020, 1050, 1080, 1110, 1140, 1170, 1200, 1230, 1260, 1290,
  1320, 1350, 1380, 1410, 1440,
].map((value) => ({
  label: value + ' Mins',
  value,
}));
